<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex form-heading title-section form-section">
              <p class="form-title text-center" style="font-size: 35px;">
                OREP PROFESSIONAL SERVICES AGREEMENT
              </p>
            </article>
            <article class="input-section form-section">
              <div >
                <p class="mb-3">
                  This Professional Services Agreement & Broker Agreement (“Agreement”) is effective as of the date this agreement is signed, (“Effective Date”), by and between the undersigned (“Client”) and OREP Insurance Services, LLC (“Broker”). Under this Agreement, the parties agree to separate services to be provided by Broker to Client and related fees, as set forth herein.
                </p>
                <p class="mb-3">
                  When applicable, Broker will make a reasonable search of the marketplace of insurers available to Broker and provide options to Client for the type of risk that Client wishes to insure based on the requirements and specifications provided by Client. Client acknowledges that no insurance coverage exists until accepted by the carrier(s) and that Broker is not obligated to change or renew any coverage without a written order. Client authorizes Broker to cancel any insurance policies if any premiums or Service Fees (defined below) remain unpaid to Broker. In addition to the Commission, Client acknowledges and agrees that Broker may receive additional compensation from insurers, finance companies, or other vendors for its professional services, which may be in a variety of forms and amounts.
                </p>
                <p class="mb-3">
                  <strong>Scope of Services:</strong>
                  Separate from the Commission, Broker will provide Client services, education, training and other value-add services (“Services”) in exchange for Client’s payment of the fees (“Service Fees”), as set forth in the below referenced Scope of Services. Client consents to the payment of the Service Fees. Client acknowledges and agrees that that the Services are separate from the Insurance Brokering and related Commissions, and provide valuable education, information and related services to Client. Client also acknowledges and agrees that the Service Fees are non-refundable and fully earned upon binding of the insurance policy, irrespective of whether the policy is later cancelled or non-renewed by Client or insurer. Client further acknowledges and agrees that the Service Fees are not part of the premium charged by any insurer, and are in addition to Commission paid by Client as well as any additional compensation Broker may receive from insurers for its professional services.
                </p>
                <p class="mb-3">
                  <strong>General: </strong>
                  This Agreement shall continue in full force until terminated by either party for any reason. The Service Fees are applicable as and to the fullest extent permissible in the applicable state/jurisdiction. If Broker adopts any enhancements to its Services during the term hereof that would otherwise increase the Services available without additional charge, such increased Services will apply to this Agreement at no extra charge to Client.
                </p>
                <p class="mb-5">
                  Broker and Client agree to the terms and conditions set forth above and on the attached Scope of Services, and acknowledge receipt of a copy of this Agreement.
                </p>
                <p>
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this transaction.                </p>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <label class="orep-label m-0">
                      CLIENT
                    </label>
                  </div>
                  <div class="col-md-6">
                    <label class="orep-label m-0">
                      BROKER
                    </label>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Signature:
                    </label>
                    <input
                      type="text"
                      name="clientSignature"
                      class="orep-text-input form-control"
                      v-model="rcApplication.clientSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      placeholder="Type Your Name to Sign"
                    >
                    <span
                      v-show="errors.has('clientSignature')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('clientSignature') | filterText }}</span>
                  </div>
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Signature:
                    </label>
                    <img src="../../../public/assets/images/sign.png" alt="Sign" style="max-height: 40px;">
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Date:
                    </label>
                    <h5 class="m-0">{{formattedCurrentDate()}}</h5>
                  </div>
                  <div class="col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Name:
                    </label>
                    <h5 class="m-0">Isaac Peck</h5>
                  </div>
                </div>
                <div class="row mb-5 justify-content-end">
                  <div class="col-md-offset-6 col-md-6 form-inline">
                    <label for class="orep-label mb-0 mr-2">
                      Title:
                    </label>
                    <h5 class="m-0">President</h5>
                  </div>
                </div>
              </div>
            </article>
            <article class="d-flex form-heading title-section form-section special-title">
              <div class="form-heading text-center mx-auto">
                <p class="form-title text-center">

                  There is no Cost or Obligation to Obtain a Quote.  Your No-Obligation Quote on the Next Page.
                </p>
                <p class="form-title text-center" style="text-decoration: underline; font-size: 35px;">
                  PROFESSIONAL SERVICE AGREEMENT “SCOPE OF SERVICES”
                </p>
              </div>                            
            </article>
            <article class="input-section form-section">
              <div class="row table-border">
                <div class="col-md-8">
                  <strong>Services:</strong>
                  <ul>
                    <li>
                      Risk management and loss control information tailored to private investigators, including a free 8 hour CE class for PIs and guaranteed delivery of Working PI
                    </li>
                  </ul>
                </div>
                <div class="col-md-4 d-flex flex-column table-left-border">
                  <strong style="text-decoration: underline">Service / RPG Fee:</strong>
                  <div class="d-flex flex-column justify-content-center flex-grow-1">
                    <strong class="text-decoration-none">Billed Annually at time insurance is bound: $30</strong>
                    <p>(Replaces $30 OREP fee of prior
                      years, where applicable.)</p>
                  </div>
                </div>
              </div>
            </article>
            <article v-if="this.$store.getters.getHostname !== 'www.liabilityinsuranceapps.com'" class="d-flex form-heading title-section form-section center-block" style="flex-direction: column; align-items: center;">
              <label for="hear_about_us" class="orep-label proposal-title blue-color" style="text-align: center; margin-bottom: 10px;margin-top: 30px;">
                <strong>How Did You Hear About Us?</strong>
              </label>
              <select
                  class="orep-select"
                  style="height: 40px; width: 383px;"
                  name="hear_about_us"
                  v-model="rcApplication.hearAboutUs"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
              >
                <option v-for="(item, key) in hear_about_us" :value="item">
                  {{ item }}
                </option>
              </select>
              <span
                  v-show="errors.has('hear_about_us')"
                  class="help is-danger form-errors text-danger"
              >
              {{ errors.first('hear_about_us') | filterText }}
            </span>

              <div class="input-section">
                <input
                    v-if="rcApplication.hearAboutUs === 'Other'"
                    type="text"
                    name="hearAboutUsOtherDetails"
                    class="orep-text-input mr-1"
                    v-model="rcApplication.hearAboutUsOtherDetails"
                    placeholder="Please Provide Details"
                    @input="validateBeforeSubmit()"
                >
                <span
                    v-show="errors.has('hearAboutUsOtherDetails')"
                    class="help is-danger form-errors text-danger"
                >{{ errors.first('hearAboutUsOtherDetails') | filterText }}</span>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'rc-application-5'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('rc-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-3')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-4')"></button>
              <button class="pagination-dots" @click="navigateToPrev('rc-application-5')"></button>
              <span class="pagination-dots pagination-current"></span>
            </article>
            <button
              class="next-btn mont spaced text-uppercase"
              :disabled="!state.pageSixIsValid"
              :class="{submitDisabled: !state.pageSixIsValid}"
              @click="formSubmit()"
            >Submit</button>
          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS, HEAR_ABOUT_US_APPRAISERS, STATUS} from "../../utils/constants";

export default {
  name: "rc-application-6",
  data() {
    return {
      hear_about_us: HEAR_ABOUT_US_APPRAISERS,
      loading: false
    };
  },
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },
    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    checkServices(service) {
      return this.rcApplication.applicantOrAssociateReportMode.includes(service);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSixIsValid = true;
          return;
        }
        this.state.pageSixIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.rcApplication.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    },
    formSubmit() {
      this.loading = true;
      this.rcApplication.status = STATUS.Submitted;
      this.rcApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('rcApplication/createRcApplication');
    }

  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
strong {
  text-decoration: underline;
}
.form-inline > label {
  width: 82px;
  text-align: left;
}
.form-heading > p {
  font-size: 35px;
  width: 100%;
  text-align: center;
  margin: 0;
}
.js-input-errors {
  display: block;
  text-transform: initial;
  font-size: 13px;
  width: 90%;
  margin: auto;
  position: relative;
  top: -29px;
}
fieldset {
  font-size: 12px;
}
.logo {
  width: 150px;
  height: 45px;
  object-fit: contain;
}
h6 {
  font-size: 14px;
}
h5 {
  font-size: 16px;
}
.company-info-content {
  padding: 10px 30px;
  border: 1px solid black;
}
.fs-subtitle {
  margin: 20px 0;
  border-bottom: 2px solid black;
}
table.oreptable {
  font-size: 14px;
  margin-left: auto;
  margin-right: auto;
}
.gen-inf {
  display: flex;
  background: #eee none repeat scroll 0 0;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 7px;
  text-align: left;
  height: 30px;
  border: 1px solid black;
}
.underline-value {
  margin-left: 10px;
  margin-right: 40px;
  border-bottom: 1px solid black;
  margin-bottom: 15px;
  font-weight: 700;
  font-size: 14px;
}
.table th, .table td {
  text-align: center;
  vertical-align: middle;
}
.table.ar td, .table.ar th {
  border-left: 1px solid #ddd !important;
  border-top: 1px solid #ddd !important;
  border-right: 1px solid #ddd !important;
}
.w-20 {
  width: 20%;
}
.blank_th {
  width: 210px;
}
.footer-company-info {
  background-color: yellow;
  border: 1px solid black;
  padding: 10px 20px 40px;
}
.form-check-input {
  position: relative;
  margin-left: 0;
}
.page-content p, .page-content li {
  font-size: 15px;
}
.p-56, .notice-list > li, .notice-info {
  padding-right: 56px;
}
</style>

